import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CASINO_FULL_URL: DiToken<string | undefined> = new DiToken<string | undefined>('casinoFullUrl', {
  factory: () => undefined
});
